module.exports = __webpack_public_path__ + "img/evaluation.f89da04b.jpg";